function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,5v7.5h12.5v5h-12.5v7.5h-5v-7.5H0v-5h12.5v-7.5h5Z",
    style: {
      fill: "#e8112d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,16.667l.833-.833h5.833v5.833l-.833.833h3.333l-.833-.833v-5.833h5.833l.833.833v-3.333l-.833.833h-5.833v-5.833l.833-.833h-3.333l.833.833v5.833h-5.833l-.833-.834v3.334Z",
    style: {
      fill: "#f9dd16"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/GG.3518bbebd2f3f8ad96079083e193b681.svg";
export { ForwardRef as ReactComponent };